import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import {confirmAlert} from "react-confirm-alert";


export default class DispositionQuestions extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
	};

	handleQuestionDetails = (question) => () => {
		let title = '';
		let message = '';
		let messagePre = '';
		if (question !== '21a') {
			title = 'Questions 21.d. - 21.n. Prohibited Persons';
			messagePre = 'Questions 21.d. - 21.n. Prohibited Persons: Generally, 18 U.S.C. § 922(g)' +
				'prohibits the shipment, transportation, receipt, or possession in or affecting interstate' +
				'commerce of a firearm by one who: has been convicted of a felony in any Federal,' +
				'including a general court-martial, State or local court, or any other crime, punishable' +
				'by imprisonment for a term exceeding one year; is a fugitive from justice; is an' +
				'unlawful user of, or addicted to, marijuana or any depressant, stimulant, or narcotic' +
				'drug, or any other controlled substance; has been adjudicated as a mental defective' +
				'or has been committed to a mental institution; has been discharged from the Armed' +
				'Forces under dishonorable conditions; is subject to certain restraining orders;' +
				'convicted of a misdemeanor crime of domestic violence under Federal, including a' +
				'general court-martial, State or Tribal law; has renounced his/her U.S. citizenship; is' +
				'an alien illegally in the United States or an alien admitted to the United States under' +
				'a nonimmigrant visa. Furthermore, 18 U.S.C. § 922(n) prohibits the shipment,' +
				'transportation, or receipt in or affecting interstate commerce of a firearm by one who' +
				'is under indictment or information for a felony in any Federal, including a general' +
				'court-martial, State or local court, or any other crime, punishable by imprisonment' +
				'for a term exceeding one year. An information is a formal accusation of a crime' +
				'verified by a prosecutor.' +
				'<br />' + '<br />' +
				'A member of the Armed Forces must answer “yes” to 21.d. if charged with an offense' +
				'that is referred to a general court-martial. A current or former member of the Armed' +
				'Forces must answer “yes” to 21.d. if convicted under a general court-martial.' +
				'<br />' + '<br />' +
				'Discharged “under dishonorable conditions” means separation from the Armed' +
				'Forces resulting from a dishonorable discharge or dismissal adjudged by a general' +
				'court-martial. That term does not include any other discharge or separation.' +
				'<br />' + '<br />' +
				'EXCEPTION: A person is not prohibited from receiving or possessing a firearm' +
				'if that person: (1) has been convicted of any Federal or State offense pertaining to' +
				'antitrust violations, unfair trade practices, restraints of trade, or other similar offenses' +
				'relating to the regulation of business practices; (2) has been convicted of a State' +
				'misdemeanor punishable by imprisonment of two years or less; or (3) following' +
				'conviction of a felony or other crime for which the judge could have imprisoned the' +
				'person for more than one year, or a misdemeanor crime of domestic violence, has' +
				'received a pardon, an expungement or set aside of the conviction, or has lost and' +
				'regained civil rights (the right to vote, sit on a jury, and hold public office) in the' +
				'jurisdiction in which the conviction occurred, AND the law of the convicting' +
				'jurisdiction does not prohibit the person from receiving or possessing firearms.' +
				'Also, a person who has no more than one conviction of a misdemeanor crime of' +
				'domestic violence against an individual in a dating relationship, and is not otherwise' +
				'prohibited under this chapter, is not prohibited if 5 years have elapsed from' +
				'conviction or completion of the person’s custodial or supervisory sentence,' +
				'whichever occurs later, and the person has not subsequently been convicted of any' +
				'other misdemeanor crime of violence, or any other offense that would disqualify the' +
				'person under 18 U.S.C. § 922(g). A person subject to any of these exceptions, or' +
				'who received relief from disabilities under 18 U.S.C. § 925(c), should answer “no”' +
				'to the applicable question';
		}

		switch (question) {
			case '21a':
				title = 'Question 21.a. Actual Transferee/Buyer';
				message = 'Question 21.a. Actual Transferee/Buyer: For purposes of this form, a person is' +
					'the actual transferee/buyer if he/she is purchasing the firearm for him/herself or' +
					'otherwise acquiring the firearm for him/herself. (e.g., redeeming the firearm from' +
					'pawn, retrieving it from consignment, firearm raffle winner). A person is also the' +
					'actual transferee/buyer if he/she is legitimately purchasing the firearm as a bona' +
					'fide gift for a third party. A gift is not bona fide if another person offered or gave' +
					'the person completing this form money, service(s), or item(s) of value to acquire' +
					'the firearm for him/her, or if the other person is prohibited by law from receiving or possessing the firearm.' +
					'<br />' + '<br />' +
					'EXAMPLES: Mr. Smith asks Mr. Jones to purchase a firearm for Mr. Smith (who' +
					'may or may not be prohibited). Mr. Smith gives Mr. Jones the money for the firearm.' +
					'Mr. Jones is NOT THE ACTUAL TRANSFEREE/BUYER of the firearm and must' +
					'answer “no” to question 21.a. The licensee may not transfer the firearm to Mr.' +
					'Jones. However, if Mr. Brown buys the firearm with his own money to give to Mr.' +
					'Black as a gift (with no service or tangible thing of value provided by Mr. Black),' +
					'Mr. Brown is the actual transferee/buyer of the firearm and should answer “yes” to' +
					'question 21.a. However, the transferor/seller may not transfer a firearm to any' +
					'person he/she knows or has reasonable cause to believe is prohibited under 18' +
					'U.S.C. § 922(g), (h), (n), or (x). ';
				break;
			case '21f':
				title = 'Question 21.f. Fugitive from Justice';
				message = 'Question 21.f. Fugitive from Justice: Any person who has fled from any State\n' +
					'to avoid prosecution for a felony or a misdemeanor; or any person who leaves the\n' +
					'State to avoid giving testimony in any criminal proceeding. The term also includes\n' +
					'any person who knows that misdemeanor or felony charges are pending against such\n' +
					'person and who leaves the State of prosecution.';
				message = messagePre + '<br /><br />' + message;
				break;
			case '21h':
				title = 'Question 21.h. Adjudicated as a Mental Defective';
				message = 'Question 21.h. Adjudicated as a Mental Defective: A determination by a court,' +
					'board, commission, or other lawful authority that a person, as a result of marked' +
					'subnormal intelligence, or mental illness, incompetency, condition, or disease: (1) is' +
					'a danger to himself or to others; or (2) lacks the mental capacity to contract or' +
					'manage his own affairs. This term shall include: (1) a finding of insanity by a court ' +
					'in a criminal case; and (2) those persons found incompetent to stand trial or found' +
					'not guilty by reason of lack of mental responsibility.' +
					'<br />' + '<br />' +
					'Committed to a Mental Institution: A formal commitment of a person to a mental' +
					'institution by a court, board, commission, or other lawful authority. The term' +
					'includes a commitment to a mental institution involuntarily. The term includes' +
					'commitment for mental defectiveness or mental illness. It also includes' +
					'commitments for other reasons, such as for drug use. The term does not include a' +
					'person in a mental institution for observation or a voluntary admission to a mental' +
					'institution.' +
					'<br />' + '<br />' +
					'EXCEPTION: Under the NICS Improvement Amendments Act of 2007, a person' +
					'who has been adjudicated as a mental defective or committed to a mental' +
					'institution in a State proceeding is not prohibited by the adjudication or commitment' +
					'if the person has been granted relief by the adjudicating/committing State pursuant' +
					'to a qualifying mental health relief from disabilities program. Also, a person who' +
					'has been adjudicated as a mental defective or committed to a mental institution by a' +
					'department or agency of Federal Government is not prohibited by the' +
					'adjudication or commitment if either: (a) the person’s adjudication or commitment' +
					'was set aside or expunged by the adjudicating/committing agency; (b) the person' +
					'has been fully released or discharged from all mandatory treatment, supervision, or' +
					'monitoring by the agency; (c) the person was found by the agency to no longer suffer' +
					'from the mental health condition that served as the basis of the initial adjudication/' +
					'commitment; (d) the adjudication or commitment, respectively, is based solely on a' +
					'medical finding of disability, without an opportunity for a hearing by a court, board,' +
					'commission, or other lawful authority, and the person has not been adjudicated as a' +
					'mental defective consistent with 18 U.S.C. § 922(g)(4) or (e) the person was' +
					'granted relief from the adjudicating/committing agency pursuant to a qualified' +
					'mental health relief from disabilities program. This exception to an adjudication or' +
					'commitment by a Federal department or agency does not apply to any person who' +
					'was adjudicated to be not guilty by reason of insanity, or based on lack of mental' +
					'responsibility, or found incompetent to stand trial, in any criminal case or under the' +
					'Uniform Code of Military Justice. Persons who fall within one of the above' +
					'exceptions should answer “no” to question 21.h. ';
				message = messagePre + '<br /><br />' + message;
				break;
			case '21j':
				title = 'Question 21.j. Qualifying Restraining Orders';
				message = 'Question 21.j. Qualifying Restraining Orders: Under 18 U.S.C. § 922, firearms' +
					'may not be sold to or received by persons subject to a court order that: (A) was' +
					'issued after a hearing which the person received actual notice of and had an' +
					'opportunity to participate in; (B) restrains such person from harassing, stalking,' +
					'or threatening an intimate partner or child of such intimate partner or person, or' +
					'engaging in other conduct that would place an intimate partner in reasonable fear of' +
					'bodily injury to the partner or child; and (C)(i) includes a finding that such person' +
					'represents a credible threat to the physical safety of such intimate partner or child;' +
					'or (ii) by its terms explicitly prohibits the use, attempted use, or threatened use' +
					'of physical force against such intimate partner or child that would reasonably be' +
					'expected to cause bodily injury. An “intimate partner” of a person is: the spouse or' +
					'former spouse of the person, the parent of a child of the person, or an individual who' +
					'cohabitates or has cohabitated with the person. ';
				message = messagePre + '<br /><br />' + message;
				break;
			case '21k':
				title = 'Question 21.k. Misdemeanor Crime of Domestic Violence';
				message = 'Question 21.k. Misdemeanor Crime of Domestic Violence: A Federal, including' +
					'a general court-martial, State, local, or tribal offense that is a misdemeanor under' +
					'Federal, State, or tribal law and has, as an element, the use or attempted use of' +
					'physical force, or the threatened use of a deadly weapon, committed by a current or' +
					'former spouse, parent, or guardian of the victim, by a person with whom the victim' +
					'shares a child in common, by a person who is cohabitating with, or has cohabited' +
					'with the victim as a spouse, parent, or guardian, or by a person who has a current or' +
					'recent former dating relationship with the victim (as defined in 18 U.S.C. § 921(a)' +
					'(37)). The term includes all misdemeanors that have as an element the use or' +
					'attempted use of physical force or the threatened use of a deadly weapon (e.g.,' +
					'assault and battery), if the offense is committed by one of the defined parties. (See' +
					'Exception to 21.d. - 21.m.) A person who has been convicted of a misdemeanor' +
					'crime of domestic violence also is not prohibited unless: (1) the person was' +
					'represented by a lawyer or gave up the right to a lawyer; or (2) if the person was' +
					'entitled to a jury, was tried by a jury, or gave up the right to a jury trial. Persons' +
					'subject to this exception should answer “no” to 21.k.' +
					'<br />' + '<br />' +
					'A current or former member of the military who has been convicted of a violation of' +
					'the Uniform Code of Military Justice that included, as an element, the use of force' +
					'against a person as identified in the instructions under question 21.k. must answer' +
					'“yes” to this question. This may include a qualifying offense that was referred to a' +
					'special or general court-martial. ';
				message = messagePre + '<br /><br />' + message;
				break;
			case '21n':
				title = 'Question 21.n. Immigration Status';
				message = 'Question 21.n. Immigration Status: An alien admitted to the United States under a' +
					'nonimmigrant visa includes, among others, persons visiting the United States' +
					'temporarily for business or pleasure, persons studying in the United States who' +
					'maintain a residence abroad, and certain temporary foreign workers. These aliens' +
					'must answer “yes” to this question and provide the additional documentation as' +
					'required under question 26.d.to establish they are excepted from the nonimmigrant' +
					'alien prohibition. Permanent resident aliens and aliens legally admitted to the United' +
					'States pursuant to either the Visa Waiver Program or to regulations otherwise exempting them from visa requirements may answer “no” to this question, leave 21.n.2' +
					'blank and are not required to submit the additional documentation under' +
					'question 26.d';
				message = messagePre + '<br /><br />' + message;
				break;
			default:
				message = messagePre;
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body" style={{maxWidth: '100%', width: '800px'}}>
							<h1 dangerouslySetInnerHTML={{__html: title}}/>
							<p dangerouslySetInnerHTML={{__html: message}}/>
							<div style={{textAlign: "center", fontSize: '16px'}}>
								<a href="https://app.fflboss.com/forms/pdfs/atf-f-4473_v3.pdf#page=3" target="_blank">
									<b>View all notices, instructions and definitions</b>
								</a>
							</div>
							<div className="react-confirm-alert-button-group">
								<div style={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
									<button onClick={onClose} style={{marginRight: 'auto'}} className={'btn btn-default'}>
										Okay
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});

	};

	render() {
		let {properties, onTextUpdate} = this.props;

		/** @type {Transactions_Questions_Object} object */
		let object = this.props.object;

		return <div>
			<h4 className="section-title">Eligibility Questions (21a - 21m and 21.1.1 - 21.1.2)</h4>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}
						onclick={this.props.handle21aRequired}
					>
						a) Are you the actual transferee/buyer of the firearm(s) listed on this form and any continuation sheet(s) (ATF Form
						5300.9A)?&nbsp;
						<b>Warning: You are not the actual transferee/buyer if you are acquiring the firearm(s) on behalf of another person. If you
							are not the actual transferee/buyer, the licensee cannot transfer the firearm(s) to you.</b>&nbsp;
						Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may
						proceed to question 21.b.&nbsp;
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.actual_transferee}
							value={object.actual_transferee}
							error={object.actual_transferee_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21a')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.a Question
					Instructions</a>
			</div>
			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						b. Do you intend to purchase or acquire any firearm listed on this form and any continuation sheet(s), or ammunition, for sale or other disposition to
						any person described in questions 21(c)-(m), or to a person described in question 21.n.1 who does not fall within a nonimmigrant alien exception?&nbsp;
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.actual_intention}
							value={object.actual_intention}
							error={object.actual_intention_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						c. Do you intend to sell or otherwise dispose of any firearm listed on this form and any continuation sheet(s) or ammunition in furtherance of any
						felony or other offense punishable by imprisonment for a term of more than one year, a Federal crime of terrorism, or a drug trafficking offense?&nbsp;
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.actual_intention_felony}
							value={object.actual_intention_felony}
							error={object.actual_intention_felony_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						d) Are you under indictment or information in any court for a <b>felony</b>, or any other crime for which the judge could
						imprison you for more
						than one year, or are you a current member of the military who has been charged with violation(s) of the Uniform Code of
						Military
						Justice and whose charge(s) have been referred to a general court-martial?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.felony_indictment}
							value={object.felony_indictment}
							error={object.felony_indictment_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21d')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.d Question
					Instructions</a>
			</div>
			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						e) Have you ever been convicted in any court, including a military court, of a <b>felony</b>, or any other crime for which the
						judge could have
						imprisoned you for more than one year, even if you received a shorter sentence including probation?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.felony_convicted}
							value={object.felony_convicted}
							error={object.felony_convicted_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21e')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.e Question
					Instructions</a>
			</div>
			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						f) Are you a fugitive from justice?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.fugitive}
							value={object.fugitive}
							error={object.fugitive_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21f')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.f Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						g) Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other controlled
						substance?
						&nbsp;<b>Warning:</b> The use or possession of marijuana remains unlawful under Federal law regardless of whether it has been
						legalized or decriminalized
						for medicinal or recreational purposes in the state where you reside.
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.drug_user}
							value={object.drug_user}
							error={object.drug_user_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21g')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.g Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						h) Have you ever been adjudicated as a mental defective <b>OR</b> have you ever been committed to a mental institution?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.mentally_stable}
							value={object.mentally_stable}
							error={object.mentally_stable_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21h')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.h Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						i) Have you ever been discharged from the Armed Forces under dishonorable conditions?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.dishonorable_discharge}
							value={object.dishonorable_discharge}
							error={object.dishonorable_discharge_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21i')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.i Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						j) Are you subject to a court order, including a Military Protection Order issued by a military judge or magistrate,
						restraining you from
						harassing, stalking, or threatening your child or an intimate partner or child of such partner?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.restraining_order}
							value={object.restraining_order}
							error={object.restraining_order_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21j')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.j Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						k) Have you ever been convicted in any court of a misdemeanor crime of domestic violence, or are you or have you ever been a
						member of
						the military and been convicted of a crime that included, as an element, the use of force against a person as identified in
						the instructions?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.domestic_violence}
							value={object.domestic_violence}
							error={object.domestic_violence_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21k')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.k Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						l) Have you ever renounced your United States citizenship?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.renounced_citizenship}
							value={object.renounced_citizenship}
							error={object.renounced_citizenship_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21l')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.l Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						m) Are you an alien <b>illegally</b> or <b>unlawfully</b> in the United States?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.illegal_alien}
							value={object.illegal_alien}
							error={object.illegal_alien_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21m')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.m Question
					Instructions</a>
			</div>

			<hr/>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						21.n.1) Are you an alien who has been admitted to the United States under a nonimmigrant visa? (U.S. citizens/nationals leave 21.n.l and 21.n.2 blank)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={properties.nonimmigrant_visa}
							value={object.nonimmigrant_visa}
							error={object.nonimmigrant_visa_error}
							update={onTextUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
			</div>
			<div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21l')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.1 Question
					Instructions</a>
			</div>
			<hr/>
			{object.nonimmigrant_visa === true ?
				<div className={'row'}>
					<div className={'col-sm-9'}>
						<p style={{marginBottom: 0}}>
							21.n.2) If you are such an alien do you fall within any of the exceptions stated in the instructions? (U.S. citizens/nationals leave 21.n.l and 21.n.2 blank)
						</p>
					</div>

					<div className={'col-sm-3 text-right'}>
						<div className={'form-group'}>
							<Framework.Elements.ButtonSwitch
								property={properties.fall_within_exceptions}
								value={object.fall_within_exceptions}
								error={object.fall_within_exceptions_error}
								update={onTextUpdate}
								autoSelect={false}
								nullable={true}
								uncheck={true}
							/>
						</div>
					</div>
				</div> : null
			}
			{object.nonimmigrant_visa === true && <div style={{textAlign: 'center', margin: 0}}>
				<a onClick={this.handleQuestionDetails('21l')} style={{cursor: "pointer", fontWeight: '800'}}>Click to read 21.1 Question
					Instructions</a>
			</div>
			}
			<hr/>
		</div>

	}
}

